export default "__VITE_ASSET__eN8_WDet__"